export default __webpack_public_path__ + "static/mediacarneasada-19b8e998802e9fa08bfe90b9d4c80eef.jpg";